<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group horizontal name="sort" :label="$t('attributes.sort')">
              <b-select v-model="form.sort" name="sort">
                <option
                  v-for="option in sortOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="status"
              attribute="attributes.status"
              :label="$t('attributes.status')"
            >
              <b-switch v-model="form.status" name="status"></b-switch>
            </form-group>

            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="picture"
              attribute="attributes.picture"
              :label="$t('attributes.picture')"
              grouped
            >
              <template #label>
                {{ $t('attributes.picture') }}
                <b-tooltip type="is-dark" label="600*400/限定jpg檔，100KB內">
                  <b-icon
                    size="is-small"
                    type="is-danger"
                    icon="help-circle-outline"
                  ></b-icon>
                </b-tooltip>
              </template>
              <b-field class="file">
                <a class="button is-primary" @click="onSelectPictureImage">
                  <b-icon icon="upload"></b-icon>
                  <span>{{ $t('message.please_select_file') }}</span>
                </a>
                <p
                  v-if="form.picture"
                  class="tag is-warning"
                  style="margin-left: 4px; height: 40px"
                >
                  <a
                    :href="bannerImage(form.picture)"
                    @click.prevent="onClickImage(bannerImage(form.picture))"
                  >
                    {{ form.picture }}
                  </a>
                </p>
              </b-field>
            </form-group>

            <form-group
              horizontal
              name="picture_alt"
              attribute="attributes.image_alt"
              :label="$t('attributes.image_alt')"
            >
              <b-input
                v-model="form.picture_alt"
                name="picture_alt"
                :placeholder="
                  $t('message.please_input') + $t('attributes.image_alt')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group horizontal name="url" :label="$t('attributes.url')">
              <b-input
                v-model="form.url"
                name="url"
                :placeholder="$t('message.please_input') + $t('attributes.url')"
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="description"
              :label="$t('attributes.description')"
            >
              <b-input
                v-model="form.description"
                name="description"
                type="textarea"
                :placeholder="
                  $t('message.please_input') + $t('attributes.description')
                "
                maxlength="500"
                expanded
              >
              </b-input>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="isLoading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="isLoading"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ shareVideo.id ? $t('attributes.update') : $t('attributes.add') }}
          </b-button>
        </footer>

        <b-loading :active.sync="isLoading" :can-cancel="false"></b-loading>
      </div>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { OpenBannerFinder } from '@/utils/ckfinder'
import notifyService from '@/services/notifyService'

export default {
  name: 'ShareVideoForm',

  props: {
    shareVideo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sending: false,
      form: this.extractFormValues(this.shareVideo),

      sortOptions: [...Array(20).keys()].map(i => i + 1),

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      sort: { required },
      status: { required },
      name: { required, maxLength: maxLength(150) },
      description: { maxLength: maxLength(500) },
      picture: { required },
      picture_alt: {},
      has_video: { required },
      url: { required, maxLength: maxLength(200) }
    }
  },
  computed: {
    formTitle() {
      let title = this.shareVideo.id
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')

      title += this.$t('attributes.video')

      return title
    },
    isLoading() {
      return this.sending
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        sort: data.sort,
        status: data.status,
        name: data.name,
        description: data.description,
        picture: data.picture,
        picture_alt: data.picture_alt,
        has_video: true,
        url: data.url
      }
    },
    async onSelectPictureImage() {
      try {
        this.form.picture = await OpenBannerFinder()
      } catch (e) {
        notifyService.error(e)
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
